import {
  Bar,
  CartesianGrid,
  BarChart as RechartsBar,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

interface BarChartProps {
  data: Array<Record<string, unknown>>
  bars: Array<{ dataKey: string; color: string; label: string }>
  xKey?: string
  title: string
}

export function BarChart({ data, bars, xKey = 'date', title }: BarChartProps) {
  return (
    <div className="rounded-lg border border-dashed border-border bg-surface p-5">
      <p className="mb-4 font-mono text-[11px] tracking-wider text-ink-faint uppercase">{title}</p>
      <ResponsiveContainer width="100%" height={220}>
        <RechartsBar data={data}>
          <CartesianGrid strokeDasharray="4 4" stroke="#E8E2DA" vertical={false} />
          <XAxis
            dataKey={xKey}
            tick={{ fontSize: 10, fontFamily: 'IBM Plex Mono', fill: '#9C9488' }}
            tickLine={false}
            axisLine={false}
            tickFormatter={(v: string) => {
              const d = new Date(v)
              return `${d.getMonth() + 1}/${d.getDate()}`
            }}
          />
          <YAxis
            tick={{ fontSize: 10, fontFamily: 'IBM Plex Mono', fill: '#9C9488' }}
            tickLine={false}
            axisLine={false}
            width={36}
          />
          <Tooltip
            contentStyle={{
              fontFamily: 'IBM Plex Mono',
              fontSize: 11,
              background: '#FDFBF8',
              border: '1px dashed #D4CFC8',
              borderRadius: 6,
            }}
          />
          {bars.map((bar) => (
            <Bar
              key={bar.dataKey}
              dataKey={bar.dataKey}
              fill={bar.color}
              radius={[3, 3, 0, 0]}
              name={bar.label}
            />
          ))}
        </RechartsBar>
      </ResponsiveContainer>
    </div>
  )
}
